const styles = {
  root: {
    flexGrow: 1
  },
  grow: {

  },

  ButtonContainer: {
    textAlign: 'right',
    flexGrow: 1

  },
  navbarColor: {
    backgroundColor: '#76427A'
  }
}

export default styles
